module.exports = __webpack_public_path__ + "src/images/measurements/fullBust.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/fullBust.jpg
// module id = 1147
// module chunks = 0